export function formatTimestamp(timestamp) {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleString('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function getUnit(probeName) {
  if (!probeName) return '';
  if (probeName.includes('TM')) return 'mm';
  if (probeName.includes('STI')) return '度';
  return '';
}

export function formatValue(value, probeName) {
  if (value === null || value === undefined) return '';
  const unit = getUnit(probeName);
  return `${value} ${unit}`.trim();
}

export function formatValueFixed(value, decimals, probeName) {
  if (value === null || value === undefined) return '';
  const unit = getUnit(probeName);
  return `${value.toFixed(decimals)} ${unit}`.trim();
}

export function roundTo(value, decimals = 4) {
  if (value === null || value === undefined || isNaN(value)) return value;
  return parseFloat(value.toFixed(decimals));
}